import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Skeleton component for UnifiedSidebar
 * Shows a clean loading state while company data is being fetched
 * Note: Does NOT use Sidebar component to avoid SidebarProvider dependency
 */
export const UnifiedSidebarSkeleton = () => {
  return (
    <aside className="w-[280px] border-r bg-background flex-shrink-0 hidden md:flex flex-col">
      <div className="flex flex-col h-full p-4">
        {/* Mode Selector Skeleton */}
        <div className="mb-6">
          <Skeleton 
            variant="default" 
            shimmer 
            className="w-full h-[60px] rounded-lg" 
          />
        </div>

        {/* Navigation Menu Skeleton */}
        <div className="space-y-4">
          <div className="space-y-2">
            <Skeleton variant="soft" shimmer className="h-3 w-20 rounded mb-3" />
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="flex items-center gap-3 p-2 rounded-lg">
                <Skeleton variant="soft" shimmer className="h-4 w-4 rounded" />
                <Skeleton variant="default" shimmer className="h-3 w-24 rounded" />
              </div>
            ))}
          </div>
        </div>

        {/* Spacer */}
        <div className="flex-1" />

        {/* User Menu Skeleton */}
        <div className="mt-auto pt-4 border-t">
          <div className="flex items-center gap-3 p-2 rounded-lg">
            <Skeleton variant="soft" shimmer className="h-8 w-8 rounded-full" />
            <div className="flex-1 space-y-1.5">
              <Skeleton variant="default" shimmer className="h-3 w-28 rounded" />
              <Skeleton variant="soft" shimmer className="h-2 w-20 rounded" />
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};
